import { render, staticRenderFns } from "./CommentPost.vue?vue&type=template&id=c124b36c&"
import script from "./CommentPost.vue?vue&type=script&lang=js&"
export * from "./CommentPost.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports